import Highcharts from "highcharts/highstock";

import "./themes"
import "./blue";
import "./dark-blue";
import "./dark-green";
import "./dark-unica";
import "./gray";
import "./green";
import "./grid";